import React, { useState, useEffect, useContext } from "react"
import {useAuthClient} from "./authClient"

import {useAppContext} from '../../context';

import { useLocalStorage } from '../../utils/useLocalStorage';
import useCookie from "../../utils/useCookie";
import { timeout } from "../../utils/useTimeout";

export const isBrowser = typeof window !== "undefined"

const defaultContext = {
    isAuthenticated: false,
    user: null,
    loading: false,
    logout: () => { },
    login: () => { },
}

export const AuthContext = React.createContext(defaultContext)
export const useAuth = () => useContext(AuthContext)
export const AuthProvider = ({
    children,
}) => {
    const authClient = useAuthClient();
    const { setLangSelection, setReady, setStarted, setCurrent } = useAppContext();
    const { setPageTransition } = useAppContext();
    
    const [user, setUser] = useLocalStorage("user");
    const [authProbe, setAuthProbe] = useCookie("_ap_", "");
    const [isAuthenticated, setIsAuthenticated] = useState()
    const [loading, setLoading] = useState(true)
    
    const updateUser = (newUser) => {
        console.log("[updateUser]", newUser);
        if (newUser) {
            setIsAuthenticated(true);
            if(newUser !== user) setUser(newUser);
            setAuthProbe(true);
        } else {
            setStarted(false);
            setReady(false);
            setLangSelection(false);
            setIsAuthenticated(false);
            setAuthProbe(null, -1);
            setUser(null);
            setCurrent(0);
        }
    }

    useEffect(() => {             
        updateUser(authProbe && authProbe.trim().length ? user : null);        
        setLoading(false) 
        console.log("[Auth Init] done");          
    }, [])


    const loginUser = async (user) => {
        console.log("loginUser", user);
        setPageTransition(true);
   //     setLoggingIn(true);
        await timeout(300);
        updateUser(user);
        await timeout(300);
        setPageTransition(false);        
    }

    const setNotAuthenticated = () => {
        updateUser(null);
    }

    const assets = async (locale, region) => {
        setPageTransition(true);    
        try {
            return await authClient.fetchAssets(locale, region);
        } catch ({ code, error, ...other }) {
            console.log("[assets]", { code }, { error }, other);
            setNotAuthenticated();
        } finally {
            setPageTransition(false);
        }
        return null;
    }

    const logout = async (params = {}) => {
        setPageTransition(true);
        try {            
            console.log("[logout]", { loading }, {isAuthenticated }, { params });
            await authClient.logout();
            return true;
        } catch (error) {
            console.log("[LOGOUT]", error);
        } finally {
            console.log("[logout] ", { loading }, {isAuthenticated });
            setNotAuthenticated();
            await timeout(300);
            setPageTransition(false);
        }
        return false;
    }
    
    return (
        <AuthContext.Provider
            value={{
                isAuthenticated,
                user,
                loading,
                logout,
      //          login,
                setLoading,
                loginUser,
                assets,               
            }}
        >
            {children}
        </AuthContext.Provider>
    )
}

